// Canonical publish command: the browser submits only an immutable Mamamiya version id.

import { CONFIG } from '../../../core/config.js'
import { createLogger } from '../../../utils/logger.js'
import { fetchWithTimeout, REQUEST_TIMEOUT_MS } from '../../../api/index.js'

const log = createLogger('shopify')

/** Publish a previously saved immutable DesignVersion. */
export async function createShopifyProductAsync(endProductData) {
  const designVersionId = endProductData?.designVersionId
  if (!designVersionId) throw new Error('Design version was not persisted')

  const token = localStorage.getItem('mms_customer_token')
  const response = await fetchWithTimeout(
    `${CONFIG.SHOPIFY_API}/api/customer/designs/publish`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        design_version_id: designVersionId,
        idempotency_key: endProductData.publishRequestId || `buy-now-${designVersionId}`,
      }),
    },
    REQUEST_TIMEOUT_MS.ANALYSIS
  )
  const result = await response.json().catch(() => null)
  if (!response.ok || !result?.success || !result.data) {
    const message = result?.error?.message || `Publish failed: ${response.status}`
    log.error('Design version publish failed:', message)
    throw new Error(message)
  }
  return result.data
}
/** Read the server-owned projection intent until it reaches a terminal state. */
export async function getPublishIntentStatus(intentId) {
  const token = localStorage.getItem('mms_customer_token')
  const response = await fetchWithTimeout(
    `${CONFIG.SHOPIFY_API}/api/customer/designs/publish-intents/${encodeURIComponent(intentId)}`,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    },
    REQUEST_TIMEOUT_MS.READ
  )
  const result = await response.json().catch(() => null)
  if (!response.ok || !result?.success || !result.data) {
    throw new Error(result?.error?.message || `Publish status failed: ${response.status}`)
  }
  return result.data
}
